import { LocalStorage } from "quasar";
import MaRefs from "src/modules/ma/classes/ma_refs";
import {
  EventItemRates,
  EventItemStateMessage,
  MessageSendingStatus,
} from "../";

export class EventItem<T = EventItemStateMessage> {
  at!: string;
  guid!: string;
  rates!: EventItemRates;
  owner_ref!: string;
  session_guid!: string;
  session_state_guid!: string;
  source_ref!: string;
  state?: T;
  type_ref!: string;
  payload!: {
    sending_status: MessageSendingStatus;
  };

  static toOldMessage(event: EventItem) {
    const state = (event.state || {}) as EventItemStateMessage;
    return {
      at: new Date(event.at),
      guid: event.guid,
      text: state?.text?.html || state?.text?.voice_chat || state?.text?.origin,
      sent: MaRefs.compareAsStr(
        event.type_ref,
        MaRefs.str.ds_event_types.client_message
      ),
      stamp: event.at ? new Date(event.at) : new Date(),
      audio_guid: state?.audio?.audio_guid,
      type: "message",
      state: state,
      login: event.owner_ref,
      isEventItem: true,
      payload: event.payload,
    };
  }

  static fromOldMessage(message: any): EventItem {
    return {
      at: message.at || new Date(),
      guid: message.guid,
      session_guid: LocalStorage.getItem("dialogId"),
      type_ref: message.sent
        ? MaRefs.str.ds_event_types.client_message
        : MaRefs.str.ds_event_types.bot_message,
      state: {
        audio: {
          audio_guid: message.audio_guid,
        },
        text: {
          origin: message.text,
          html: message.text,
          clear: message.clearText,
          voice_chat: message.text,
          voice_sip: message.text,
          is_markdown: false,
        },
        attachments: message.state?.files ?? [],
      },
      payload: message.payload,
    } as EventItem;
  }

  static getTextForPlay(event: EventItem): string {
    return (
      (MaRefs.compareAsStr(event?.source_ref, MaRefs.str.ds_sources.sip)
        ? event?.state?.text?.voice_sip
        : event?.state?.text?.voice_chat) ||
      event?.state?.text?.origin ||
      event?.state?.text?.clear ||
      ""
    );
  }

  static getTextForCopy(event: EventItem): string {
    return event?.state?.text?.clear || event?.state?.text?.origin || "";
  }

  static getTextForView(event: EventItem): { value: string; is_html: boolean } {
    let value = undefined;
    if (MaRefs.compareAsStr(event?.source_ref, MaRefs.str.ds_sources.sip)) {
      value = event?.state?.text?.voice_sip;
    }
    if (!value && event?.state?.text?.html) {
      return {
        value: event?.state?.text?.html,
        is_html: true,
      };
    } else {
      return {
        value:
          value ||
          event?.state?.text?.origin ||
          event?.state?.text?.clear ||
          event?.state?.text?.voice_chat ||
          "",
        is_html: false,
      };
    }
  }
}
